import { toast } from 'react-toastify'

import { errorToast } from 'common/components/toastNotification'

export const GENERATION_WAIT_TIMEOUT_TOAST_ID = 'generation-wait-timeout'

const GENERATION_WAIT_TIMEOUT_MESSAGE = 'Generation timed out.'

export const showGenerationWaitTimeoutToast = (onRetry: () => void) => {
  errorToast(
    <span>
      {GENERATION_WAIT_TIMEOUT_MESSAGE}{' '}
      <button
        type="button"
        className="underline font-medium"
        data-testid="generation-wait-retry"
        onClick={() => {
          toast.dismiss(GENERATION_WAIT_TIMEOUT_TOAST_ID)
          onRetry()
        }}
      >
        Retry
      </button>
    </span>,
    {
      autoClose: false,
      toastId: GENERATION_WAIT_TIMEOUT_TOAST_ID,
    }
  )
}
